export default {"src":"/_next/static/media/loading-indicator.7092c6e9.gif","height":66,"width":66,"blurWidth":0,"blurHeight":0};